module.exports = __webpack_public_path__ + "img/lens-167-plus-00.a77742d0.png";